import axios from "axios";
import { BASE_URL } from "../constants/applicationConfig";

export class RefreshTokenApi {
  // Uses plain axios rather than axiosInstance so a failed refresh doesn't
  // trigger the 401 interceptor (which would redirect to /login).
  static async refresh() {
    return await axios.post(
      `${BASE_URL}/api/refresh-token`,
      {},
      { withCredentials: true },
    );
  }
}
